// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__uTZp1","head__title":"styles_head__title__bX8X8"};